export default {
  STATUS: {
    PENDING: 0,
    APPROVED: 1,
    DISAPPROVED: 2,
  },
  MERGE: '_MERGE_TEMP',
};
